import { createContext } from 'react';
import { Disposable } from 'record-it-utils/utils/DisposableContainer/DisposableContainer';

export const PageLoadingOverlayContext =
  createContext<PageLoadingOverlayContextValue>({
    startLoading: () => {
      return { dispose: () => {} };
    },
    addLoadingMessage: () => {}
  });

export type PageLoadingOverlayContextValue = {
  startLoading: () => Disposable;
  addLoadingMessage: (message: string) => void;
};
